import type { YAXisComponentOption } from 'echarts'

/** Show the free cursor level with the same precision used by double-click alerts. */
export function oiValueAxisPointer(): YAXisComponentOption['axisPointer'] {
  return {
    snap: false,
    triggerTooltip: false,
    lineStyle: { color: '#94a3b8', type: 'dashed' },
    label: {
      show: true,
      backgroundColor: '#52619c',
      color: '#fff',
      fontSize: 11,
      formatter: ({ value }) => Number(value).toLocaleString(undefined, { maximumSignificantDigits: 12 }),
    },
  }
}
